// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_iy-0";